import { CategoryDC } from "app/data/categories/category.types"
import { ImageDC } from "app/data/image/image.types"
import { TagDC } from "app/data/tag/tag.types"
import { LocaleD } from "db"
import * as t from "io-ts"
import * as td from "io-ts-types"

const AuthorDC = t.type({
  name: t.string,
})

export type AuthorD = t.TypeOf<typeof AuthorDC>

const PageTranslationLC = <T extends LocaleD>(locale: T) =>
  t.type({
    content: t.object,
    locale: t.literal(locale),
    summary: t.string,
    title: t.string,
  })

const ArticlePageDC = t.type({
  id: t.number,
  leadImage: ImageDC,
  number: t.number,
  translations: t.tuple([PageTranslationLC("en_ca"), PageTranslationLC("fr_ca")]),
})

export type ArticlePageD = t.TypeOf<typeof ArticlePageDC>

const ArticleTranslationDC = <T extends LocaleD>(locale: T) =>
  t.type({
    locale: t.literal(locale),
    slug: t.string,
  })

export const ArticleDC = t.type({
  authors: td.nonEmptyArray(AuthorDC),
  categories: t.array(CategoryDC),
  createdAt: td.date,
  id: t.number,
  pages: td.nonEmptyArray(ArticlePageDC),
  publishedAt: td.date,
  tags: t.array(TagDC),
  translations: t.tuple([ArticleTranslationDC("en_ca"), ArticleTranslationDC("fr_ca")]),
  updatedAt: td.date,
})

export type ArticleD = t.TypeOf<typeof ArticleDC>

export const ArticlePathsDC = t.type({
  _count: t.type({ pages: t.number }),
  translations: t.tuple([
    t.type({
      locale: t.literal("en_ca"),
      slug: t.string,
    }),
    t.type({
      locale: t.literal("fr_ca"),
      slug: t.string,
    }),
  ]),
  updatedAt: td.date,
})
